import { setError, signUp } from '../store/auth'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import Alert from 'react-bootstrap/Alert'
import Breadcrumb from '../components/Breadcrumb'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'
import Spinner from '../components/Spinner'
import classNames from 'classnames'
import { initialize } from '../store/pagedata'
import styles from '../styles/signin.module.scss'
import useDarkMode from 'use-dark-mode'

const SignUp = () => {
  const darkMode = useDarkMode(false)
  const dispatch = useDispatch()
  const error = useSelector((state) => state.auth.error)
  const isLoading = useSelector((state) => state.auth.isLoading)
  const success = useSelector((state) => state.auth.success)
  const [email, setEmail] = useState('')
  const [passwordOne, setPasswordOne] = useState('')
  const [passwordTwo, setPasswordTwo] = useState('')
  const [username, setUsername] = useState('')

  useEffect(() => {
    dispatch(initialize())
  }, [])

  const onSubmit = (e) => {
    e.preventDefault()

    if (passwordOne !== passwordTwo) {
      dispatch(setError('Passwords must match'))
    } else {
      dispatch(signUp({ email, password: passwordOne, username }))
    }
  }

  return (
    <>
      <Helmet>
        <meta name='description' content='EDHREC Sign Up' />
        <meta name='keywords' content='EDHREC,sign,up' />
        <title>Sign Up | EDHREC</title>
      </Helmet>
      <Breadcrumb breadcrumb={[{ '/signup': 'Sign Up' }]} />
      <h4 className='page-heading'>Sign Up</h4>
      <div
        className={classNames(styles.container, {
          [styles.dark]: darkMode.value,
        })}
      >
        <div className={styles.containerInner}>
          <h2>Sign Up</h2>
          <form onSubmit={onSubmit}>
            <Form.Group>
              <Form.Label>Email</Form.Label>
              <Form.Control
                onChange={(e) => setEmail(e.target.value)}
                placeholder='Email'
                type='email'
                value={email}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Username</Form.Label>
              <Form.Control
                onChange={(e) => setUsername(e.target.value)}
                placeholder='Username'
                type='text'
                value={username}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Password</Form.Label>
              <Form.Control
                onChange={(e) => setPasswordOne(e.target.value)}
                placeholder='Password'
                type='password'
                value={passwordOne}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Confirm Password</Form.Label>
              <Form.Control
                onChange={(e) => setPasswordTwo(e.target.value)}
                placeholder='Confirm Password'
                type='password'
                value={passwordTwo}
              />
            </Form.Group>
            <Form.Group>
              <Button
                className='btn-block'
                disabled={isLoading}
                type='submit'
                variant='primary'
              >
                {isLoading ? <Spinner /> : 'Sign Up'}
              </Button>
            </Form.Group>
            <Form.Group>
              {error && <Alert variant='danger'>{error}</Alert>}
              {success && <Alert variant='success'>{success}</Alert>}
            </Form.Group>
            <Form.Group className='align-items-center d-flex flex-column'>
              <Link to={{ pathname: '/signin', state: { noTop: true } }}>
                I already have an account.
              </Link>
            </Form.Group>
            <p></p>
          </form>
        </div>
      </div>
    </>
  )
}

export default SignUp
